import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-cell-full')
export class ObiCellFull extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M2.737 13.875C3.229 15.0917 3.95 16.2 4.9 17.2L6.1 16C5.3 15.2 4.7 14.279 4.3 13.237C3.9 12.1957 3.7 11.15 3.7 10.1C3.7 9.05 3.9 8.004 4.3 6.962C4.7 5.92067 5.3 5 6.1 4.2L4.9 3C3.95 4 3.229 5.10833 2.737 6.325C2.24567 7.54167 2 8.8 2 10.1C2 11.4 2.24567 12.6583 2.737 13.875Z" fill="currentColor"/>
<path d="M5.812 12.6C6.154 13.4167 6.65 14.15 7.3 14.8L8.5 13.6C8 13.1 7.625 12.5417 7.375 11.925C7.125 11.3083 7 10.7 7 10.1C7 9.45 7.125 8.81667 7.375 8.2C7.625 7.58333 8 7.05 8.5 6.6L7.3 5.4C6.65 6.05 6.154 6.78333 5.812 7.6C5.47067 8.41667 5.3 9.25 5.3 10.1C5.3 10.95 5.47067 11.7833 5.812 12.6Z" fill="currentColor"/>
<path d="M15.5 13.6L16.7 14.8C17.35 14.15 17.846 13.4167 18.188 12.6C18.5293 11.7833 18.7 10.95 18.7 10.1C18.65 9.25 18.4667 8.41667 18.15 7.6C17.8333 6.78333 17.35 6.05 16.7 5.4L15.5 6.6C16 7.1 16.375 7.65833 16.625 8.275C16.875 8.89167 17 9.5 17 10.1C17 10.75 16.875 11.3833 16.625 12C16.375 12.6167 16 13.15 15.5 13.6Z" fill="currentColor"/>
<path d="M17.9 16L19.1 17.2C20.1 16.2 20.8333 15.0917 21.3 13.875C21.7667 12.6583 22 11.4 22 10.1C22 8.8 21.7543 7.54167 21.263 6.325C20.771 5.10833 20.05 4 19.1 3L17.9 4.2C18.7 5 19.3 5.92067 19.7 6.962C20.1 8.004 20.3 9.05 20.3 10.1C20.3 11.15 20.1 12.1957 19.7 13.237C19.3 14.279 18.7 15.2 17.9 16Z" fill="currentColor"/>
<path d="M15 10C15 11.3062 14.165 12.4175 13 12.8291V22H11V12.8291C9.83496 12.4175 9 11.3062 9 10C9 8.34326 10.3428 7 12 7C13.6572 7 15 8.34326 15 10Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.737 13.875C3.229 15.0917 3.95 16.2 4.9 17.2L6.1 16C5.3 15.2 4.7 14.279 4.3 13.237C3.9 12.1957 3.7 11.15 3.7 10.1C3.7 9.05 3.9 8.004 4.3 6.962C4.7 5.92067 5.3 5 6.1 4.2L4.9 3C3.95 4 3.229 5.10833 2.737 6.325C2.24567 7.54167 2 8.8 2 10.1C2 11.4 2.24567 12.6583 2.737 13.875Z" style="fill: var(--element-active-color)"/>
<path d="M5.812 12.6C6.154 13.4167 6.65 14.15 7.3 14.8L8.5 13.6C8 13.1 7.625 12.5417 7.375 11.925C7.125 11.3083 7 10.7 7 10.1C7 9.45 7.125 8.81667 7.375 8.2C7.625 7.58333 8 7.05 8.5 6.6L7.3 5.4C6.65 6.05 6.154 6.78333 5.812 7.6C5.47067 8.41667 5.3 9.25 5.3 10.1C5.3 10.95 5.47067 11.7833 5.812 12.6Z" style="fill: var(--element-active-color)"/>
<path d="M15.5 13.6L16.7 14.8C17.35 14.15 17.846 13.4167 18.188 12.6C18.5293 11.7833 18.7 10.95 18.7 10.1C18.65 9.25 18.4667 8.41667 18.15 7.6C17.8333 6.78333 17.35 6.05 16.7 5.4L15.5 6.6C16 7.1 16.375 7.65833 16.625 8.275C16.875 8.89167 17 9.5 17 10.1C17 10.75 16.875 11.3833 16.625 12C16.375 12.6167 16 13.15 15.5 13.6Z" style="fill: var(--element-active-color)"/>
<path d="M17.9 16L19.1 17.2C20.1 16.2 20.8333 15.0917 21.3 13.875C21.7667 12.6583 22 11.4 22 10.1C22 8.8 21.7543 7.54167 21.263 6.325C20.771 5.10833 20.05 4 19.1 3L17.9 4.2C18.7 5 19.3 5.92067 19.7 6.962C20.1 8.004 20.3 9.05 20.3 10.1C20.3 11.15 20.1 12.1957 19.7 13.237C19.3 14.279 18.7 15.2 17.9 16Z" style="fill: var(--element-active-color)"/>
<path d="M15 10C15 11.3062 14.165 12.4175 13 12.8291V22H11V12.8291C9.83496 12.4175 9 11.3062 9 10C9 8.34326 10.3428 7 12 7C13.6572 7 15 8.34326 15 10Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-cell-full': ObiCellFull;
  }
}
